import getAgentActivityResponse from './fixtures/case_manager/agent_activity';
import getClientResponse from './fixtures/client';
import productsResponse from './fixtures/products';
import healthQuestionsResponse from './fixtures/health-questions';
import quoteQuestionsResponse from './fixtures/quote-questions';
import preApprovalResponse from './fixtures/preApprovalResponse';
import {AxiosRequestConfig} from 'axios';
var mockedQuoteNANone = require('./fixtures/mockedQuotes/NA_None.json');
var mockedQuoteNATableB = require('./fixtures/mockedQuotes/NA_TableB.json');
var mockedQuoteRoundedUpAge = require('./fixtures/mockedQuotes/Correct_Rounded_Up_Nearest_Age_Quote.json');
var mockedQuoteRoundedDownAge = require('./fixtures/mockedQuotes/Correct_Rounded_Down_Nearest_Age_Quote.json');

const setupMocks = (mockedInstance: any) => {
    const agentActivityMatch = new RegExp('http://localhost:3000/agent-activity/....-..-..');
    const getCustomerConsentCodeMatch = new RegExp('http://localhost:3000/customer/.*/.*/.*/consent-code');
    const sendSMSActivityMatch = new RegExp('http://localhost:3000/sms');
    const sendQuoteRequestMatch = new RegExp('http://localhost:3000/ixn/v1/quotes');
    const clientMatch = new RegExp('http://localhost:3000/client/.*/....-..-..-.*');
    const productsMatch = new RegExp('http://localhost:3000/settings/products.json');
    const healthQuestionsMatch = new RegExp('http://localhost:3000/health-questions.*');
    const quoteQuestionsMatch = new RegExp('http://localhost:3000/quote-questions.*');
    const preApprovalMatch = new RegExp('http://localhost:3000/pre-approval.*');
    //not going to implement this one just yet
    const walkthroughDataMatch = new RegExp(`http://localhost:3000/customer/.*/walkthrough`);

    mockedInstance.onGet(agentActivityMatch).reply((config: AxiosRequestConfig) => {
        const date: string | undefined = config.url?.split('/')[1];
        const reply = {mocked: getAgentActivityResponse(date)};
        return [200, reply];
    });

    mockedInstance.onPost(getCustomerConsentCodeMatch).reply((config: AxiosRequestConfig) => {
        const reply = {mocked: {code: 'ABCDEF'}};
        return [200, reply];
    });

    mockedInstance.onPost(sendSMSActivityMatch).reply((config: AxiosRequestConfig) => {
        var data = JSON.parse(config.data);
        if (data.phone === '+18554458516') {
            return [200, {mocked: {status: 'success'}}];
        } else {
            return [400];
        }
    });

    mockedInstance.onPost(sendQuoteRequestMatch).reply((config: AxiosRequestConfig) => {
        var data = JSON.parse(config.data).data;

        let carrierId = '';
        let tableRate = '';
        let nearestAge = '';
        // eslint-disable-next-line no-restricted-syntax
        for (const element of data) {
            if (element.name === 'carrier_ids[]') {
                carrierId = element.value;
            } else if (element.name === 'table_rates[]') {
                tableRate = element.value;
            } else if (element.name === 'nearest_age') {
                nearestAge = element.value;
            }
        }

        // 139 and none or table b are test cases for table value
        if (carrierId === '139' && tableRate === 'None') {
            return [200, {mocked: mockedQuoteNANone}];
        }
        if (carrierId === '139' && tableRate === 'Table B') {
            return [200, {mocked: mockedQuoteNATableB}];
        }
        if (carrierId === '139' && nearestAge === '40') {
            return [200, {mocked: mockedQuoteRoundedUpAge}];
        }
        if (carrierId === '139' && nearestAge === '39') {
            return [200, {mocked: mockedQuoteRoundedDownAge}];
        } else {
            return [400];
        }
    });

    mockedInstance.onGet(clientMatch).reply((config: AxiosRequestConfig) => {
        const reply = {mocked: getClientResponse()};
        return [200, reply];
    });

    mockedInstance.onGet(productsMatch).reply((config: AxiosRequestConfig) => {
        const reply = {mocked: productsResponse};
        return [200, reply];
    });

    mockedInstance.onGet(healthQuestionsMatch).reply((config: AxiosRequestConfig) => {
        const reply = {mocked: healthQuestionsResponse};
        return [200, reply];
    });

    mockedInstance.onGet(quoteQuestionsMatch).reply((config: AxiosRequestConfig) => {
        const reply = {mocked: quoteQuestionsResponse};
        return [200, reply];
    });

    mockedInstance.onGet(preApprovalMatch).reply((config: AxiosRequestConfig) => {
        const reply = {mocked: preApprovalResponse};
        return [200, reply];
    });
};

export default setupMocks;
